import Breadcrumb from '@/components/feature/Breadcrumb';

export default function FaqHeader() {
  return (
    <section className="bg-secondary-500 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />
        <h1 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h1>
        <p className="mt-3 max-w-2xl text-foreground-900 md:text-lg">
          关于更新提醒、收藏管理、追漫日历与进度保存的常见疑问，在这里找到答案。
        </p>
      </div>
    </section>
  );
}